module.exports = __webpack_public_path__ + "static/img/4762_phase_function_Paper_PointsHejduk_Prediction.39a7e50.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4762_phase_function_Paper_PointsHejduk_Prediction.png
// module id = /HVu
// module chunks = 0